import React, { useEffect, useState } from "react";
import "./styles.scss";
import { AdCategoryCard, FormHeader } from "../../components";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { CreateNewAdCategory } from "../CreateNewItem";
import { getLanguage } from "../../utils/environment";
import Scrollbars from "react-custom-scrollbars-2";
import { useDispatch, useSelector } from "react-redux";
import { getAllAdvSubCategory } from "../CreateNewItem/CreateNewAdvertisement/service/advertisement.service";
import {
  setAdvCategory,
  setAdvCategoryList,
} from "../advertisement/redux/actions";

const lan = getLanguage();

const AdvCategory = () => {
  const dispatch = useDispatch();
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [selectAdvCategory, setSelectAdvCategory] = useState("");

  const categoryList = useSelector(
    (state) => state.advertismentReducer.categoryList
  );

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  useEffect(() => {
    const fetchData = async () => {
      try {
        const getList = await getAllAdvSubCategory();
        console.log("Get All Adv Category : ", getList);

        if (getList?.data) {
          dispatch(setAdvCategoryList(getList.data));
        } else {
          console.log("Data Not Found");
        }
      } catch (error) {
        console.log("Error fetching Data", error);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <div className="hne-ad-category-wrapper">
        <div className="col-9 ad-category-body-wrapper">
          <FormHeader
            data={{
              formHeader: "Adv Category",
              size: "md-md",
            }}
          />
          <div className="hne-ad-cetgory-header-wrapper">
            <div className="achw-id">Id</div>
            <div className="achw-category">Category name</div>
            <div className="achw-status">Sub Category</div>
          </div>
          <div className="hne-ad-category-body-wrapper">
            <Scrollbars
              onScroll={handleOnScroll}
              renderView={(props) => (
                <div
                  {...props}
                  style={{ ...props.style, overflowX: "hidden" }}
                />
              )}
              style={{ height: viewPointHeight - 218 }}
            >
              <div className={"hne_adv-category-wrapper "}>
                {Array.isArray(categoryList) && categoryList.length > 0 ? (
                  categoryList.map((category) => (
                    <AdCategoryCard
                      isSelect={selectAdvCategory === category?.category_id}
                      id={category.category_id}
                      category={category.category_name}
                      subcategory={category.sub_category_name}
                      edit="Edit"
                      onClick={() => {
                        setSelectAdvCategory(category?.category_id);
                        dispatch(setAdvCategory(category));
                      }}
                    />
                  ))
                ) : (
                  <div className="error-message">No Category Found</div>
                )}
              </div>
            </Scrollbars>
          </div>
        </div>

        {/*right side*/}
        <div className="col-3 ad-category-right-side-wrapper">
          <CreateNewAdCategory />
        </div>
      </div>
    </>
  );
};
export default withRouter(AdvCategory);
